import { AxiosApi } from "./index";
import { useInfoStore } from "store/error";
import { PickListFilter } from "api/pickList";
import { SalesNoteJournalFilter } from "api/sales";
import { SalesNoteFilter } from "api/salesNote";
import { LandingNoteJournalFilter } from "api/landingNoteoJournal";

export async function getPdfApi(guid: string) {
    const apiUri = "Pdf/Get"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                guid
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getSoldFrozenWeeklyReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/GetSoldFrozenWeekly"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getSoldFrozenDailyReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/GetSoldFrozenDaily"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getPickListReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/PickListReport"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getPurchaseStatisticsReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/PurchaseStatisticsReport"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getSalesNoteListReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/SalesNoteListReport"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getSoldFreshReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/GetSoldFresh"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getWeeklyTurnoverReportApi(filter: PickListFilter) {
    const apiUri = "Pdf/WeeklyTurnover"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getSalesNoteJournalReportApi(filter: SalesNoteJournalFilter) {
    const apiUri = "Pdf/SalesNoteJournal"
    try {
        const result = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return result.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export interface AccountStatementReportFilter {
    buyerLedgerAccount?: number;
    year: number;
    periodFrom?: number;
    periodTo?: number;
}

export async function getAccountStatementReportApi(filter: AccountStatementReportFilter) {
    const apiUri = "Pdf/AccountStatementReport"
    try {
        const result = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return result.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getLandingNoteJournalReportApi(filter: LandingNoteJournalFilter) {
    const apiUri = "Pdf/LandingNoteJournalReport"
    try {
        const result = await AxiosApi.get<string>(apiUri, {
            params: {
                ...filter,
            }
        })

        return result.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}
